


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";




const firebaseConfig = {
  apiKey: "AIzaSyBZuuU3tFd0opvhR8ffQZjgnd-cwoCo1os",
  authDomain: "a-to-z-opticals.firebaseapp.com",
  projectId: "a-to-z-opticals",
  storageBucket: "a-to-z-opticals.firebasestorage.app",
  messagingSenderId: "612578989196",
  appId: "1:612578989196:web:c11e73fad3ee991c4957a9"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export